import { cn } from '@/utils';
import React from 'react';
import { INTRODUCES } from './data';

const ServiceIntroduction: React.FC = () => {
  return (
    <section>
      <div className="container px-10 lg:py-0">
        <div className="relative">
          <div className="lg:flex lg:flex-row items-center">
            <div className="flex-[2] my-10">
              <div className="w-[15rem] aspect-[240/53]">
                <img src="/images/logo-with-text-primary.png" alt="countfit" />
              </div>
              <h4 className="mt-16 text-[2.25rem] font-medium">카운트핏의 서비스를 시작해 보세요.</h4>
              <p className="mt-2 text-[1.2rem] text-foreground-accent text-gray-500">
                앱에서 간편하게 PT일지 생성과 전송
                <br />
                운동인식밴드를 통한 회원의 운동여부 체크
                <br />
                회원별 맞춤 운동루틴 전송까지 가능한 원격피티 솔루션
              </p>
              <div className="mt-16 flex gap-4 items-center z-10">
                <a className="px-8 py-3 bg-white rounded-[20px] cursor-pointer shadow-md hover:shadow-lg transition-all duration-300 shadow-gray-300" href="https://play.google.com/store/apps/details?id=ai.countfit2.trainer">
                  <div className="w-32">
                    <img className="w-full h-full" src="/images/store-google-play.png" alt="Google Play" />
                  </div>
                </a>
                <a className="px-8 py-3 bg-white rounded-[20px] cursor-pointer shadow-md hover:shadow-lg transition-all duration-300 shadow-gray-300" href="https://apps.apple.com/us/app/카운트핏-트레이너/id6673890073">
                  <div className="w-32">
                    <img className="w-full h-full" src="/images/store-app-store.png" alt="App Store" />
                  </div>
                </a>
              </div>
            </div>
            <div className="flex-1 max-h-[750px] aspect-[855/1795] relative lg:scale-100 scale-75">
              <img className="lg:absolute bottom-[5rem] left-0" src="/images/app-sample.png" alt="SAMPLE" />
            </div>
          </div>
          <div className="w-full absolute bottom-8 left-0 flex flex-col justify-end items-center">
            <span className="text-[1.5rem] font-extrabold">view-more</span>
            <img className="mt-4 animate-bounce" src="/images/arrow-down.png" alt="GO DOWN" />
          </div>
        </div>
      </div>
      <div id="service-introduce">
        {INTRODUCES.map((introduce, i) => (
          <div key={i} className={i % 2 === 0 ? 'bg-background-accent' : 'bg-white'}>
            <div className={cn('container px-10 py-20 flex flex-col items-center', 'md:flex-row', 'gap-16')}>
              <div className={cn('flex md:scale-100 scale-75', 'justify-start')}>
                <img src={`/images/introduce${i + 1}.png`} alt={i.toString()} className="rounded-full border border-gray-400" />
              </div>
              <div className="flex-1 md:mt-0 mt-8">
                <p className="text-primary text-[2.5rem] font-black">{(i + 1).toString().padStart(2, '0')}</p>
                <h4 className="text-[2.0rem] font-medium leading-[1.2] whitespace-pre-wrap">{introduce.title}</h4>
                <p
                  className="mt-4 [&>span]:text-primary [&>span]:font-bold text-[1.2rem] leading-[1.4] text-gray-500"
                  dangerouslySetInnerHTML={{ __html: introduce.description }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceIntroduction;
